// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2-cy8","checkboxCol":"Table_checkboxCol__227dk","emailCol":"Table_emailCol__-vnRP","actionCol":"Table_actionCol__2SXpf"};